import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { usePlatform } from "@platform/PlatformContext";

export function useRedirectWhenAnonymous(path: string = "/login") {
  const { user, isPlatformClosed } = usePlatform();

  const { pathname } = useLocation();

  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      // If platform is closed, redirect to home instead of login
      if (isPlatformClosed) {
        navigate("/", { replace: true });
      } else {
        navigate(`${path}?redirect=${pathname}`);
      }
    }
  }, [user, isPlatformClosed, path, pathname, navigate]);
}

export default useRedirectWhenAnonymous;
